var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 24,
    viewBox: "0 0 19 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3333 16.333V16.7472L15.6262 17.0401L17.4191 18.833H1.24755L3.04044 17.0401L3.33333 16.7472V16.333V10.4997C3.33333 7.25508 5.01937 4.76152 7.81388 4.0994L8.58333 3.91709V3.12634V2.33301C8.58333 1.91696 8.91728 1.58301 9.33333 1.58301C9.74938 1.58301 10.0833 1.91696 10.0833 2.33301V3.12634V3.91646L10.852 4.09922C13.6362 4.7612 15.3333 7.26764 15.3333 10.4997V16.333ZM10.2111 21.9997C9.97578 22.2067 9.66805 22.333 9.33333 22.333C8.99415 22.333 8.68561 22.207 8.45095 21.9997H10.2111Z",
    fill: "white",
    stroke: "#707683",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.ca9459131bbb659dc9323cfbc853669c.svg";
export { ForwardRef as ReactComponent };